<div class="transition-view h-100 d-flex align-items-center justify-content-center">
    <div class="flex-container">
        <h1 class="flex-text"> {{ transitionText | translate }} </h1>
    </div>
</div>
